"use client";

import {
    NavigationMenu,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
} from "@/components/ui/navigation-menu";
import { NavigationMenuProps } from "@radix-ui/react-navigation-menu";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { useLanguage } from "@/lib/LanguageContext";

export const NavMenu = (props: NavigationMenuProps) => {
    const t = useTranslations('marketing.navbar');
    const { language } = useLanguage();

    const navItems = [
        { href: "/", label: t('home') || "Home" },
        { href: "#features", label: t('features') },
        { href: `/${language}/pricing`, label: t('pricing') },
        { href: `/${language}/blog`, label: t('blog') || "Blog" },
        { href: `/${language}/contact`, label: t('contact') || "Contact" },
    ];

    return (
        <NavigationMenu {...props}>
            <NavigationMenuList className="gap-6 space-x-0 data-[orientation=vertical]:flex-col data-[orientation=vertical]:items-start">
                {navItems.map((item) => (
                    <NavigationMenuItem key={item.href}>
                        <NavigationMenuLink asChild>
                            <Link
                                href={item.href}
                                className="text-muted-foreground hover:text-foreground transition-colors"
                            >
                                {item.label}
                            </Link>
                        </NavigationMenuLink>
                    </NavigationMenuItem>
                ))}
            </NavigationMenuList>
        </NavigationMenu>
    );
};

export default NavMenu;
